export class ReportDto{
    id = 1;
    reportName = '';
    reportId = 'Test';
    reportCategory = '';
    workspaceId = '';
    resource = '';
}